/* 🤖 this file was generated by script */
export const wiconCircle = {
  name: 'circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 22a10 10 0 100-20 10 10 0 000 20z"/></svg>`,
};
